export default __webpack_public_path__ + "static/media/logo.67fcb910.svg";